import {DocumentSearchService} from '|shared';
import {SearchRecordSourceDocumentFileDto} from '|api/elastic';
import {of} from 'rxjs';
import {FilterOperator, IczTableDataSource} from '@icz/angular-table';
import {StorageUnitDto} from '|api/document';

export class ObjectsForStorageUnitInsertDatasource extends IczTableDataSource<SearchRecordSourceDocumentFileDto> {
  constructor(searchService: DocumentSearchService, storageUnit: Nullable<StorageUnitDto>) {
    super(
      searchParams => {
        if (storageUnit) {
          if (storageUnit.fileCabinetId) {
            searchParams.filter.push(
              {
                fieldName: 'fileCabinetId',
                operator: FilterOperator.equals,
                value: storageUnit.fileCabinetId,
              },
            );
          } else {
            searchParams.filter.push(
              {
                fieldName: 'fileCabinetId',
                operator: FilterOperator.empty,
                value: '',
              },
            );
          }
          return searchService.findAllEntitiesForStorageUnitInsert(searchParams, storageUnit.id);
        }
        else {
          return of({
            content: [],
            numberOfElements: 0,
            last: false,
            first: false,
            totalElements: 0
          });
        }
      },
    );
  }
}
